import { ReactElement } from 'react';
import { Global } from '@emotion/react';
import { Dropdown as AntDropdown, DropdownProps } from 'antd';
import { dropdownGlobalStyles } from './Dropdown.global.style';

export const Dropdown = ({ children, overlayClassName, ...restProps }: DropdownProps): ReactElement => (
  <div>
    <Global styles={dropdownGlobalStyles} />
    <AntDropdown overlayClassName={['custom-ant-dropdown', overlayClassName].join(' ')} {...restProps}>
      {children}
    </AntDropdown>
  </div>
);
